<div class="mb-3">
  <app-alerts />
</div>

<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="mb-6 rounded-md border border-gray-200 p-8 pr-16">
    <h6 class="uppercase">Dane płatności</h6>

    <div class="grid grid-cols-2 gap-x-4">
      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Imię">
        <input
          [formControl]="form.controls.billingAddress.controls.firstName"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Nazwisko">
        <input
          [formControl]="form.controls.billingAddress.controls.lastName"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Nazwa firmy">
        <input
          [formControl]="form.controls.billingAddress.controls.companyName"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="NIP">
        <input
          [formControl]="form.controls.billingAddress.controls.companyNip"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        inputId="1857b57b-fbf7-4b75-81ea-2d978c7550da"
        label="Kraj">
        <p-select
          [formControl]="form.controls.billingAddress.controls.countryId"
          [options]="valueOrDefault(countrySelectItems$ | async, [])"
          appPrimengSelect
          [fluid]="true"
          inputId="1857b57b-fbf7-4b75-81ea-2d978c7550da">
        </p-select>
      </app-form-control>

      @if (billingStateControlAvailability$ | async) {
        <app-form-control
          [floatLabel]="true"
          [underlineInputStyle]="true"
          label="Region">
          <input
            [formControl]="form.controls.billingAddress.controls.state"
            appPrimengInputText
            pInputText />
        </app-form-control>
      }
    </div>

    <div class="grid grid-cols-2 items-end gap-x-4">
      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Adres">
        <input
          [formControl]="form.controls.billingAddress.controls.streetLine1"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Adres cd.">
        <input
          [formControl]="form.controls.billingAddress.controls.streetLine2"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>
    </div>

    <div class="grid grid-cols-2 items-end gap-x-4">
      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Kod pocztowy">
        <input
          [formControl]="form.controls.billingAddress.controls.postCode"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Miasto">
        <input
          [formControl]="form.controls.billingAddress.controls.city"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Numer telefonu">
        <app-phone-number-with-prefix
          [formControl]="form.controls.billingAddress.controls.phone" />
      </app-form-control>

      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Adres e-mail">
        <input
          [formControl]="form.controls.billingAddress.controls.email"
          appPrimengInputText
          pInputText
          type="text" />
      </app-form-control>
    </div>

    <div class="mt-4">
      <app-form-control inputId="c02cca5f-c27c-4ac6-a5e2-66ab96183883">
        <app-checkbox-with-label
          inputId="c02cca5f-c27c-4ac6-a5e2-66ab96183883"
          type="short">
          <p-checkbox
            [binary]="true"
            [formControl]="form.controls.otherShippingAddress" />

          <span label>Inny adres wysyłki</span>
        </app-checkbox-with-label>
      </app-form-control>
    </div>
  </div>

  @if (shippingAddressVisibility()) {
    <div class="mb-6 rounded-md border border-gray-200 p-8">
      <h6 class="uppercase">Dane do wysyłki</h6>

      <div class="grid grid-cols-2 gap-x-4">
        <app-form-control
          label="Imię"
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <input
            [formControl]="form.controls.shippingAddress.controls.firstName"
            appPrimengInputText
            pInputText
            type="text" />
        </app-form-control>

        <app-form-control
          label="Nazwisko"
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <input
            [formControl]="form.controls.shippingAddress.controls.lastName"
            pInputText
            appPrimengInputText
            type="text" />
        </app-form-control>

        <app-form-control
          label="Nazwa firmy"
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <input
            [formControl]="form.controls.shippingAddress.controls.companyName"
            pInputText
            appPrimengInputText
            type="text" />
        </app-form-control>

        <app-form-control
          label="Kraj"
          inputId="b27b2433-40f1-4b79-b82c-3f43c23f524a"
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <p-select
            inputId="b27b2433-40f1-4b79-b82c-3f43c23f524a"
            [formControl]="form.controls.shippingAddress.controls.countryId"
            [options]="valueOrDefault(countrySelectItems$ | async, [])"
            appPrimengSelect
            [fluid]="true">
          </p-select>
        </app-form-control>

        @if (shippingStateControlAvailability$ | async) {
          <app-form-control
            [floatLabel]="true"
            [underlineInputStyle]="true"
            label="Region">
            <input
              [formControl]="form.controls.shippingAddress.controls.state"
              appPrimengInputText
              pInputText />
          </app-form-control>
        }
      </div>

      <div class="grid grid-cols-2 items-end gap-x-4">
        <app-form-control
          label="Ulica"
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <input
            [formControl]="form.controls.shippingAddress.controls.streetLine1"
            pInputText
            appPrimengInputText
            type="text" />
        </app-form-control>

        <app-form-control
          label="Adres cd."
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <input
            [formControl]="form.controls.shippingAddress.controls.streetLine2"
            pInputText
            appPrimengInputText
            type="text" />
        </app-form-control>
      </div>

      <div class="grid grid-cols-2 items-end gap-x-4">
        <app-form-control
          [floatLabel]="true"
          [underlineInputStyle]="true"
          label="Kod pocztowy">
          <input
            [formControl]="form.controls.shippingAddress.controls.postCode"
            pInputText
            appPrimengInputText
            type="text" />
        </app-form-control>

        <app-form-control
          label="Miasto"
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <input
            [formControl]="form.controls.shippingAddress.controls.city"
            pInputText
            appPrimengInputText
            type="text" />
        </app-form-control>

        <app-form-control
          label="Numer telefonu"
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <app-phone-number-with-prefix
            [formControl]="form.controls.shippingAddress.controls.phone" />
        </app-form-control>

        <app-form-control
          label="Adres e-mail"
          [floatLabel]="true"
          [underlineInputStyle]="true">
          <input
            [formControl]="form.controls.shippingAddress.controls.email"
            pInputText
            appPrimengInputText
            type="text" />
        </app-form-control>
      </div>
    </div>
  }

  <div class="mb-6 rounded-md border border-gray-200 p-8">
    <h6 class="uppercase">Metody dostawy</h6>

    <app-form-control
      [floatLabel]="true"
      [hint]="shippingMethodHint$ | async"
      [underlineInputStyle]="true"
      inputId="97f76260-6db7-4e79-bdff-f39b3165a4a1"
      label="Rodzaj wysyłki">
      <p-select
        [formControl]="form.controls.shippingMethodId"
        [options]="valueOrDefault(shippingMethodSelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true"
        inputId="97f76260-6db7-4e79-bdff-f39b3165a4a1">
      </p-select>
    </app-form-control>

    @if (currentCountryCode$ | async; as country) {
      @if (currentShippingMethod$ | async; as method) {
        <div class="mb-4 text-sm">
          <app-summernote-html-preview [html]="method.description" />
        </div>

        @if (method.isInternationalInPostGeowidget) {
          <app-form-control>
            <app-in-post-point-select
              [international]="true"
              [country]="country"
              [formControl]="form.controls.shippingPoint" />
          </app-form-control>
        }

        @if (method.isDomesticInPostGeowidget) {
          <app-form-control>
            <app-in-post-point-select
              [international]="false"
              [country]="country"
              [formControl]="form.controls.shippingPoint" />
          </app-form-control>
        }
      }
    }
  </div>

  @if (currentShippingMethod$ | async) {
    @if (valueOrDefault(paymentMethods$ | async, []); as methods) {
      <div class="mb-6 rounded-md border border-gray-200 p-8">
        <h6 class="uppercase">Metody płatności</h6>

        @for (method of methods; track method.id) {
          <app-form-control [withBottomMargin]="false">
            <div>
              <div class="relative inline-flex items-center gap-2">
                <p-radio-button
                  class="flex"
                  [inputId]="method.id"
                  [value]="method.id"
                  [formControl]="form.controls.paymentMethod" />

                <label [for]="method.id">
                  {{ method.name }}
                </label>

                @if (method.previewFile; as file) {
                  <div
                    class="absolute top-1/2 -right-14 flex size-12 -translate-y-1/2 justify-center">
                    <app-image-thumbnail size="full">
                      <img
                        [fill]="true"
                        [ngSrc]="file.url"
                        [alt]="file.alt"
                        class="object-contain" />
                    </app-image-thumbnail>
                  </div>
                }
              </div>
            </div>
          </app-form-control>
        }

        @if (currentPaymentMethod$ | async; as payment) {
          <div class="mt-4 bg-gray-50 px-4 pt-4 pb-1 text-sm text-gray-700">
            <app-summernote-html-preview [html]="payment.description" />
          </div>
        }
      </div>
    }
  }

  <div class="mb-6 rounded-md border border-gray-200 p-8">
    <h6 class="uppercase">Uwagi do zamówienia</h6>

    <div class="mt-4">
      <app-form-control
        [floatLabel]="true"
        [underlineInputStyle]="true"
        label="Uwagi do zamówienia">
        <textarea
          [formControl]="form.controls.comment"
          appPrimengTextarea
          pTextarea></textarea>
      </app-form-control>
    </div>
  </div>

  <div class="bg-gray-50 p-4 text-sm text-gray-700">
    <div class="mb-4">
      Twoje dane osobowe będą użyte do przetworzenia twojego zamówienia, obsługi
      twojej wizyty na naszej stronie oraz dla innych celów o których mówi nasza
      polityka prywatności.
    </div>

    <app-form-control inputId="83adeeb2-e5a4-402c-926b-492a480c99b3">
      <app-checkbox-with-label inputId="83adeeb2-e5a4-402c-926b-492a480c99b3">
        <p-checkbox
          [binary]="true"
          [formControl]="form.controls.regulations" />
        <app-regulations-checkbox-label label />
      </app-checkbox-with-label>
    </app-form-control>

    <app-form-control inputId="d8a1f233-762a-4571-a3a8-07cbb492ca48">
      <app-checkbox-with-label inputId="d8a1f233-762a-4571-a3a8-07cbb492ca48">
        <p-checkbox
          [binary]="true"
          [formControl]="form.controls.newsletter" />
        <app-newsletter-checkbox-label label />
      </app-checkbox-with-label>
    </app-form-control>

    <app-privacy-policy-clause />
  </div>

  <div class="mt-4 flex justify-end text-sm">
    @if (checkoutPending()) {
      <app-spinner-filled />
    } @else {
      <p-button
        appPrimengButton
        label="Zamawiam z obowiązkiem zapłaty"
        type="submit" />
    }
  </div>
</form>
